module.exports = __webpack_public_path__ + "assets/img/icon9-menu2.255bdd99.svg";